/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CloudFormationStack } from './cloudFormationStack';
import { RdsDeletionInfo } from './rdsDeletionInfo';
import { AWSSecrets } from './aWSSecrets';
import { EC2PlacementGroup } from './eC2PlacementGroup';
import { Network } from './network';
import { Ec2InstanceDeletionInfo } from './ec2InstanceDeletionInfo';
import { RDSDbSubnet } from './rDSDbSubnet';
import { S3BucketDeletionInfo } from './s3BucketDeletionInfo';


export interface DeleteAWSResourceResponse { 
    aws_secrets?: Array<AWSSecrets>;
    buckets?: { [key: string]: S3BucketDeletionInfo; };
    cloud_formation_stacks?: Array<CloudFormationStack>;
    dynamodb_table?: Array<string>;
    ec2_instances?: { [key: string]: Ec2InstanceDeletionInfo; };
    ec2_volumes?: Array<string>;
    ec2_key_pairs?: Array<string>;
    ec2_placement_groups?: Array<EC2PlacementGroup>;
    lambda_triggers?: Array<string>;
    lambdas?: Array<string>;
    network?: Array<Network>;
    rds_cluster?: { [key: string]: RdsDeletionInfo; };
    rds_instances?: { [key: string]: RdsDeletionInfo; };
    rds_snapshot?: Array<string>;
    rds_subnets?: Array<RDSDbSubnet>;
}

